import React from "react";
import "./NoPermissions.css";

function NoPermissions({ message } = {}) {
	return (
		<div className="no-permissions">
			<div className="no-permissions-content">
				<h2>Access Denied</h2>
				<p>
					{message ||
						"You don't have permission to view this page. Contact an administrator if you need access."}
				</p>
				<p className="no-permissions-contact">Contact Frank</p>
			</div>
		</div>
	);
}

export default NoPermissions;
